import { AppointmentStatusConfig } from '../types';

export const APPT_STATUS: Record<string, AppointmentStatusConfig> = {
  REQUESTED: { label: 'Requested', color: 'bg-amber-100 text-amber-700', icon: 'Bell' },
  SCHEDULED: { label: 'Scheduled', color: 'bg-blue-100 text-blue-700', icon: 'Clock' },
  CONFIRMED: { label: 'Confirmed', color: 'bg-emerald-100 text-emerald-700', icon: 'CheckCircle' },
  CHECKED_IN: { label: 'Checked-In', color: 'bg-purple-100 text-purple-700', icon: 'UserCircle' },
  COMPLETED: { label: 'Completed', color: 'bg-slate-100 text-slate-700', icon: 'ShieldCheck' },
  CANCELLED: { label: 'Cancelled', color: 'bg-red-100 text-red-700', icon: 'XCircle' },
  NO_SHOW: { label: 'No-Show', color: 'bg-orange-100 text-orange-700', icon: 'AlertCircle' },
  RESCHEDULED: { label: 'Rescheduled', color: 'bg-yellow-100 text-yellow-700', icon: 'Calendar' },
};

export const ROOMS = ['Chair 1', 'Chair 2', 'Chair 3', 'Chair 4'];
